'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    state: {
      type: String,
      default: 'online'
    },

    digital: {
      type: Object,
      default: function _default() {
        return {
          online: {
            title: 'online',
            value: '-',
            lottie: []
          },
          offline: {
            title: '',
            value: '已离线',
            lottie: []
          }
        };
      }
    },
    position: {
      type: String,
      default: 'static'
    },
    textColor: {
      type: String,
      default: ''
    },
    panelTop: {
      type: [Number, String],
      default: 0
    },
    textTop: {
      type: [Number, String],
      default: 0
    }
  },
  data: function data() {
    return {
      appName: 'dof-digital'
    };
  },

  computed: {
    dynamicWrapperStyle: function dynamicWrapperStyle() {
      var state = this.state,
          panelTop = this.panelTop;


      if (state === 'offline') {
        return {
          height: '600px',
          marginTop: panelTop
        };
      } else {
        return {
          height: '724px',
          marginTop: panelTop
        };
      }
    },
    lottieComp: function lottieComp() {
      var defaultLottieSizeConfig = {
        width: '750px',
        height: '600px',
        loop: true
      };
      var digital = this.digital,
          state = this.state;

      console.log(digital[state]);
      return digital[state]['lottie'].map(function (item, index) {
        if (index === 0) {
          return _extends({}, defaultLottieSizeConfig, item);
        } else {
          return _extends({}, item);
        }
      });
    },
    digitalComp: function digitalComp() {
      var digital = this.digital,
          state = this.state;

      return _extends({}, digital[state]);
    },
    digitalStyleComp: function digitalStyleComp() {
      var textTop = this.textTop;

      return {
        marginTop: textTop
      };
    },
    dynamicStateTextSize: function dynamicStateTextSize() {
      var state = this.state;

      if (state === 'online') {
        return '';
      } else {
        return 'main-text-size-offline';
      }
    },
    positionComp: function positionComp() {
      var position = this.position;

      if (position === 'absolute') {
        return {
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0
        };
      } else {
        return {};
      }
    },
    textColorComp: function textColorComp() {
      var textColor = this.textColor;

      if (textColor) {
        return {
          color: textColor
        };
      } else {
        return null;
      }
    }
  },
  methods: {
    alignStyleCalc: function alignStyleCalc(i, arr) {
      if (arr.length === 1) {
        return 'desc-align-center';
      } else {
        return i === 0 ? 'desc-align-end' : '';
      }
    },
    textColorCalc: function textColorCalc(data) {
      if (data.color) {
        return {
          color: data.color
        };
      } else {
        return {};
      }
    },
    StatusBarBgColorCalc: function StatusBarBgColorCalc(data) {
      var state = this.state;

      if (!data.statusBarBgColor) {
        if (state === 'offline') {
          return '#7c879b';
        } else {
          return 'transparent';
        }
      } else {
        return data.statusBarBgColor;
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-digital-panel/index.vue
// module id = 333
// module chunks = 0 1